module.exports = __webpack_public_path__ + "media/assets/Close-9d26f0308b9bd004d46c7bc01584a9fd.svg";